import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

import { IAP_PRICING_BASE_PATH } from '../utils/pathsConstants';
import { handleError } from '../utils/utils';

import { ApiAvailableStore } from '../types/enums/store.enum';

export type SkuStorefrontStatus =
    | 'PUBLISHED'
    | 'NOT_PUBLISHED'
    | 'NOT_FOUND'
    | 'ERROR';

export type SkuStatus = {
    sku: string;
    status: SkuStorefrontStatus;
    error: string;
};

export type SkuStatusesResponse = {
    skus: SkuStatus[];
};

async function fetchSkuStatuses(store: ApiAvailableStore, onlyActive: boolean) {
    const storePath =
        store === ApiAvailableStore.APPLE ? 'applestore' : 'googleplay';
    const { data } = await axios.patch<SkuStatusesResponse>(
        `/api/${IAP_PRICING_BASE_PATH}/${storePath}/inapppurchases/sku-status`,
        undefined,
        {
            params: { onlyActive },
        },
    );
    return data;
}

export function useSkuStatuses(store: ApiAvailableStore) {
    const { mutate, data, isPending, error } = useMutation({
        mutationFn: (onlyActive: boolean) =>
            fetchSkuStatuses(store, onlyActive),
    });

    return {
        checkSkuStatuses: mutate,
        skuStatuses: data,
        isChecking: isPending,
        errorMessage: error
            ? handleError("Couldn't check SKU statuses", error, false)
            : undefined,
    };
}
